import { mutate } from 'swr';
import { createGet, createMutation, simpleGet } from '../hooks/useApi';
import {
    Option,
    SystemInfo,
    SystemOptionEntry,
    SystemOptionType,
    SystemOptionsEntry,
} from '../models/System';
import { safeUrl } from '../utils/safeUrl';

export const systemApi = {
    get: {
        info: createGet<SystemInfo>(`/public/info`, null, {
            refreshInterval: 5000,
            errorRetryInterval: 1000,
        }),
        option: (option: Option) =>
            simpleGet<SystemOptionEntry>`/system/option/${option.category}/${option.key}`,
        optionValue: (option: Option) => ({
            ...systemApi.get.option(option),
            postProcess({ data }: { data: SystemOptionEntry }): any {
                if (data.type === 'boolean') {
                    return !!data.value;
                }
                return data.value;
            },
        }),
        // SystemAdministrator のみ
        options: createGet(
            '/system/options',
            async ({ authenticated }, key, config) => {
                const res = await authenticated.get<{
                    data: SystemOptionsEntry[];
                }>(key, config);
                return res.data;
            }
        ),
    },
    mutate: {
        option: createMutation<
            {
                option: Option;
                type: SystemOptionType;
                value: any;
            },
            {}
        >({
            async effect() {
                await Promise.all([
                    mutate(
                        (key) => {
                            if (typeof key !== 'string') {
                                return false;
                            }
                            if (key.startsWith(`/system/option/`)) {
                                return true;
                            }
                            return false;
                        },
                        undefined,
                        { revalidate: true }
                    ),
                    systemApi.get.options.mutate(),
                ]);
            },
            async mutate({ authenticated }, { option, value, type }, opts) {
                return await authenticated.post(
                    safeUrl`/system/option/${option.category}/${option.key}`,
                    {
                        type,
                        value,
                    },
                    opts
                );
            },
        }),
    },
};
